<template>
  <div id="app">
    <Header 
      v-if="started"
      :demoProgression="demoProgression"
      :langTxt="langTxt"
    />

    <div v-if="demoProgression[0].demoStart" class="step-container">
      <div class="step-one">1</div>
      <div class="join-one"></div>
      <div class="step-two">2</div>
      <div class="join-two"></div>
      <div class="step-three">3</div>
      <div class="join-three"></div>
      <div class="step-four">4</div>
    </div>

    <Welcome
      v-if="demoProgression[0].demoStart == false && started"
      :demoProgression="demoProgression"
      :randPic="randPic"
      :langTxt="langTxt"
    />
    <transition name="fade">
      <WelcomeMailCheck
        v-if="
          demoProgression[0].demoStart &&
            demoProgression[0].completedMail == false
        "
        :demoProgression="demoProgression"
        :randPic="randPic"
        :langTxt="langTxt"
        @mail-checked="mailChecked"
      />
    </transition>
    <transition name="fade">
      <WelcomeNameCheck
        v-if="
          demoProgression[0].completedMail &&
            demoProgression[0].completedName == false
        "
        :demoProgression="demoProgression"
        :randPic="randPic"
        :langTxt="langTxt"
        @name-checked="nameChecked"
      />
    </transition>
    <transition name="fade">
      <WelcomePhoneCheck
        v-if="
          demoProgression[0].completedName &&
            demoProgression[0].completedPhone == false
        "
        :demoProgression="demoProgression"
        :randPic="randPic"
        :langTxt="langTxt"
        @phone-checked="phoneChecked"
      />
    </transition>
    <transition name="fade">
      <EndValidation
        v-if="demoProgression[0].completedPhone"
        :demoProgression="demoProgression"
        :randPic="randPic"
        :langTxt="langTxt"
        @send-clicked="sendClicked"
      />
    </transition>
    <transition name="fade">
      <div
        class="filter-back"
        v-if="demoProgression[0].sendClicked || demoProgression[0].preview"
      ></div>
    </transition>
    <p v-if="started" style="display:none;">{{ langTxt.header.logo }}</p>
  </div>
</template>

<script>

import axios from "axios";
import Header from "./components/layout/Header.vue";
import Welcome from "./components/Welcome.vue";
import WelcomeMailCheck from "./components/WelcomeMailCheck.vue";
import WelcomeNameCheck from "./components/WelcomeNameCheck.vue";
import WelcomePhoneCheck from "./components/WelcomePhoneCheck.vue";
import EndValidation from "./components/EndValidation.vue";
import tradJson from "../public/trad.json";

export default {
  name: "app",
  components: {
    Header,
    Welcome,
    WelcomeMailCheck,
    WelcomeNameCheck,
    WelcomePhoneCheck,
    EndValidation,
  },
  data() {
    return {
      randPic: Math.floor(Math.random() * 5),
      langTxt: false,
      started: false,
      demoProgression: [
        {
          demoStart: false,
          // "DEMO2020"
          promoCode: tradJson.promoCode, 
          mail: "",
          completedMail: false,
          name: "",
          firstname: "",
          completedName: false,
          phone: "",
          completedPhone: false,
          sendClicked: false,
          preview: false,
        },
      ],
    };
  },
  created() {
    this.sendData();
  },
  methods: {
    mailChecked() {
      let stepOneCheck = document.querySelector(".step-one");
      stepOneCheck.classList.add("check-step");
      let joinOneCheck = document.querySelector(".join-one");
      joinOneCheck.classList.add("join-check-step");
    },
    nameChecked() {
      let stepTwoCheck = document.querySelector(".step-two");
      stepTwoCheck.classList.add("check-step");
      let joinTwoCheck = document.querySelector(".join-two");
      joinTwoCheck.classList.add("join-check-step");
    },
    phoneChecked() {
      let stepThreeCheck = document.querySelector(".step-three");
      stepThreeCheck.classList.add("check-step");
      let joinThreeCheck = document.querySelector(".join-three");
      joinThreeCheck.classList.add("join-check-step");
    },
    sendClicked() {
      let stepFourCheck = document.querySelector(".step-four");
      stepFourCheck.classList.add("check-step");
    },
    sendData() {
      // axios
      //   .get("./php/require/api.php")
      //   .then(function() {})
      //   .catch(function() {
      //     console.log("erreur envoi impossible");
      //   });

      axios
        .get("./trad.json")
        .then((response) => (this.langTxt = response.data))
          .then(() => (this.started = true))
        .catch(function() {
          console.log("error");
        });

        // setTimeout(() => this.started = true, 250);

    }
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  outline: none;
  list-style-type: none;
  text-decoration: none;
  box-sizing: border-box;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.step-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
  margin: auto;
  padding: 20px;
  padding-top: 10px;
}

.step-one,
.step-two,
.step-three,
.step-four {
  background-color: rgb(167, 167, 167);
  opacity: 0.6;
  width: 50px;
  height: 50px;
  font-size: 20px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 25px;
  font-weight: bold;
  cursor: default;
}
.check-step {
  background-color: #7c9048;
  opacity: 0.8;
}
.join-check-step {
  background-color: #7c9048 !important;
  opacity: 0.8 !important;
}
.join-one,
.join-two,
.join-three {
  width: 15%;
  height: 3px;
  background-color: rgb(167, 167, 167);
  opacity: 0.6;
}
.filter-back {
  background: rgb(153, 153, 153);
  opacity: 0.6;
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0px;
  left: 0px;
  border-radius: 10px;
  z-index: 10;
}
.fade-enter-active {
  transition: opacity 1.5s;
}
.fade-leave-active {
  transition: opacity;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.backstep {
  width: 40px;
  height: 40px;
  position: absolute;
  top: 15px;
  left: 15px;
  font-size: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(167, 167, 167);
  border-radius: 10px;
  border: none;
  box-shadow: #e6e6e6 4px 4px 8px;
  cursor: pointer;
}
input[type="text"] {
  -webkit-appearance: none;
}

@media screen and (max-width: 1200px) {
  .step-container {
    width: 55%;
  }
}

@media screen and (max-width: 800px) {
  .step-container {
    width: 100%;
  }
}
</style>
